// initLoadMoreProducts.js

export default function initLoadMoreProducts() {
    const btnLoadMore = document.querySelector('.js-load-more');
    const productsGrid = document.querySelector('.js-products-grid');

    if (!btnLoadMore || !productsGrid) return;

    btnLoadMore.addEventListener('click', async (e) => {
        e.preventDefault();

        // NOVIDADE: Seleciona apenas o span de texto para não apagar o ícone SVG!
        const labelText = btnLoadMore.querySelector('.c-compound-btn__label');
        if (!labelText) return;

        // 1. Estados de Loading
        const originalText = labelText.textContent.trim();
        labelText.textContent = 'CARREGANDO...';
        btnLoadMore.style.opacity = '0.7';
        btnLoadMore.style.pointerEvents = 'none';

        // 2. Resgata as variáveis embutidas no botão via data-attributes
        const ajaxUrl = btnLoadMore.getAttribute('data-ajax-url');
        const termId = btnLoadMore.getAttribute('data-term-id');
        let currentPage = parseInt(btnLoadMore.getAttribute('data-page'), 10);
        const nextPage = currentPage + 1;

        // 3. Prepara os dados para o WordPress
        const formData = new FormData();
        formData.append('action', 'pdr_load_more_products');
        formData.append('term_id', termId);
        formData.append('paged', nextPage);

        try {
            // 4. Faz a chamada
            const response = await fetch(ajaxUrl, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.success) {
                // Insere os novos produtos no final do grid
                productsGrid.insertAdjacentHTML('beforeend', data.data.html);

                // Atualiza a página atual no botão
                btnLoadMore.setAttribute('data-page', nextPage);

                // Se chegou na última página, some com o botão
                if (nextPage >= data.data.max_pages) {
                    btnLoadMore.style.display = 'none';
                } else {
                    // Se ainda tem página, restaura o botão
                    labelText.textContent = originalText;
                    btnLoadMore.style.opacity = '1';
                    btnLoadMore.style.pointerEvents = 'auto';
                }
            } else {
                console.error('Erro na resposta do servidor.');
                restaurarBotao(btnLoadMore, labelText, originalText);
            }
        } catch (error) {
            console.error('Erro de conexão no Load More:', error);
            restaurarBotao(btnLoadMore, labelText, originalText);
        }
    });

    // Helper caso dê erro
    function restaurarBotao(btn, label, textoOriginal) {
        label.textContent = textoOriginal;
        btn.style.opacity = '1';
        btn.style.pointerEvents = 'auto';
    }
}